<script>
    import InfoPageTemplate from './InfoPageTemplate.svelte';
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    onMount(() => {
        window.scrollTo(0, 0);
    });
</script>

<style>
    h3 {
        text-align: left;
        font-weight: 800;
    }
    li {
        margin-bottom: var(--spacingMedium);
    }

    .list {
        max-width: 530px;
        margin: auto;
    }

    ul {
        padding-left: var(--spacingXLarge);
    }
    
    .img-section {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .info-img {
        object-fit: cover;
        margin: var(--spacingLarge) var(--spacingMedium);
    }

    .info-img.portrait {
        max-width: 220px;
        max-height: 300px;
        width: 30vw;
        height: 40vw;
    }

    .info-img.landscape {
        max-width: 300px;
        max-height: 220px;
        width: 40vw;
        height: 30vw;
    }
</style>

<InfoPageTemplate>
    <div slot="header-section">
        <h1>{$_('learn.infopage_1.title')}</h1>
    </div>
    <div slot="content-section">
        <div class="img-section">
            <img class="info-img landscape" src="/img/hoftext2.png" alt="{$_('learn.infopage_1.img3_alt')}" />
        </div>
        <div class="list">

            <h3>{$_('learn.infopage_1.content_title')}:</h3>
            <ul>
                {#each $_('learn.infopage_1.content_list') as list_entry}
                    <li>{list_entry}</li>
                {/each}
            </ul>
        </div>
        <div class="img-section">
            <img class="info-img portrait" src="/img/knaext.png" alt="{$_('learn.infopage_1.img1_alt')}" />
            <img class="info-img portrait" src="/img/hoftflex2.png" alt="{$_('learn.infopage_1.img2_alt')}" />
        </div>
    </div>
    <div slot="footer-section">
        <h3>{$_('learn.infopage_1.footer_title')}:</h3>
        <ul>
            {#each $_('learn.infopage_1.footer_list') as list_entry}
                <li>{list_entry}</li>
            {/each}
        </ul>
    </div>
</InfoPageTemplate>